"use client";

import React from "react";
import { Card, CardFooter, Avatar, Button, Badge, CardBody, AvatarGroup } from "@nextui-org/react";


import { Job } from "@/types/types";

interface FeaturesTableProps {
    job: Job;
}

const CVHeaderBadge: React.FC<FeaturesTableProps> = ({ job }) => {
    return (
        <div className="flex gap-3 items-center justify-start">
            <Badge content="1" color="danger" placement="top-right">
                <Avatar
                    isBordered
                    radius="md"
                    src="https://i.pravatar.cc/150?u=a042f81f4e29026024d"
                    className="hover:scale-150"
                />
            </Badge>
            <Badge content="5+" color="danger" placement="bottom-right">
                <Avatar
                    isBordered
                    radius="md"
                    src="https://i.pravatar.cc/150?u=a04258a2462d826712d"
                    className="hover:scale-150"
                />
            </Badge>
            <Badge content="3" color="danger" placement="top-left">
                <Avatar
                    isBordered
                    radius="md"
                    src="https://i.pravatar.cc/150?u=a04258114e29026708c"
                    className="hover:scale-150"
                />
            </Badge>
            <Badge content="2" color="danger" placement="bottom-left">
                <Avatar
                    isBordered
                    radius="md"
                    src="https://i.pravatar.cc/150?u=a04258114e29026302d"
                    className="hover:scale-150"
                />
            </Badge>
        </div>
    );
}

export default CVHeaderBadge;